import causesData from 'testdata/causesData'

export const getCausesData = (field, value) => {
  if (!field || !value) {
    return causesData
  } else if (field && value) {
    
    for (let i = 0; i < causesData.length; i ++) {
      if (causesData[i][`${field}`] == value) {
        return causesData[i]
      }
    }
  }
}